import React from "react";
import PropTypes from "prop-types";
import styles from "./LOSPluginList.module.css";
import LOSPluginItem from "../LOSPluginItem";

/**
 * Interactive component. Scrollable list of all users with a header.
 */
export function LOSPluginList({ plugins }) {
  return (
    <>
      <div className={styles.container}>
        <div className={styles.headerGrid}>
          <div className={styles.headerItem}>ID</div>
          <div className={styles.headerItem}>Plugged in IBO</div>
          <div className={styles.headerItem}>Plugged Into</div>
          <div className={styles.headerItem}>Plugin Pin</div>
          <div className={styles.headerItem}>Replace</div>
          <div className={styles.headerItem}>Status</div>
        </div>

        <div className={styles.pluginContainer}>
          {plugins.map((plugin, index) => (
            <div
              className={
                index % 2 === 0 ? styles.backgroundWhite : styles.backgroundGray
              }
            >
              <LOSPluginItem
                pluginInfo={{
                  id: plugin.id,
                  pluggedInIbo: plugin.pluggedInIbo,
                  pluggedInto: plugin.pluggedInto,
                  pluginPin: plugin.pluginPin,
                  replace: plugin.replace,
                  status: plugin.status,
                }}
              />
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

LOSPluginList.propTypes = {
  plugins: PropTypes.arrayOf(PropTypes.object),
};
